import { RSF } from "../../rsf";



export class RSFRefresh {
  static readonly type = '[RSF] Refresh';
}

export class RSFRefreshById {
  static readonly type = '[RSF] RefreshById';
  constructor(public id: number) { }
}

export class RSFCreate {
  static readonly type = '[RSF] Create';

  constructor(public item: RSF) { }
}

export class RSFUpdate {
  static readonly type = '[RSF] Update';

  constructor(public id: number, public item: RSF) { }
}

export class RSFDelete {
  static readonly type = '[RSF] Delete';
  constructor(public id: number) { }
}
